import { login, logout, register } from '@/apis/auth.api';
import type { LoginResponse } from '@/types/api/candidate';
import type { IRegisterUser, IUserLogin } from '@/types/common/general';
import { fetchMeIsAuthenticated } from '@/utils/authMe';
import { http } from './http.service';

class AuthService {
  async login(user: IUserLogin): Promise<LoginResponse['data']> {
    return login(user).then(response => {
      return response.data as LoginResponse['data'];
    });
  }

  async logout(): Promise<void> {
    try {
      await logout();
    } finally {
      delete http.defaults.headers.common['Authorization'];
      this.clearCache();
    }
  }

  async register(user: IRegisterUser): Promise<unknown> {
    return register(user);
  }

  clearCache(): void {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('access_token');
    localStorage.removeItem('auth_state');
    localStorage.removeItem('auth_time');
  }

  getUser(): Record<string, unknown> | null {
    const user = localStorage.getItem('user');

    if (user) {
      try {
        return JSON.parse(user) as Record<string, unknown>;
      } catch {
        return null;
      }
    }

    return null;
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  async isAuthenticated(options?: { force?: boolean }): Promise<boolean> {
    const ok = await fetchMeIsAuthenticated(options);
    if (!ok) {
      localStorage.removeItem('auth_state');
      localStorage.removeItem('auth_time');
    }
    return ok;
  }
}

const instance = new AuthService();

export default instance;
